<template>
  <div>
    <div class="page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">
          <i class="fas fa-home"></i>
          {{ $t('pages.home') }}
        </h4>
      </div>
      <loading-container :loading="this.form.portfolioListLoading">
        <div class="headline-row">
          <FormButton type="" inputType="submit" iconClass="fas fa-plus" :text="$t('common.v_portfolio')"
            :click="() => { showCreatePortfolioPanel = true }" class="btn btn-transparent" />
          <div v-if="vplist.total > 0" v-for="item in vplist.items" :key="item.id">
            <Headline v-if="item.id === 'watchlist'" iconClass="fas fa-list-ul" :id="item.id" :name="item.name"
              :number="item.noOfSymbols" :active="activeTab.id === item.id" @clicked="setActiveTab(item)" />
            <Headline v-else :iconClass="item.mode === 'experiment' ? 'fas fa-vial' : 'fas fa-vials'" :id="item.id" :name="item.name" :number="item.noOfSymbols"
              :active="activeTab.id === item.id" @clicked="setActiveTab(item)" />
            <!-- <Headline v-else iconClass="far fa-chart-bar" :id="item.id" :name="item.name" :number="item.noOfSymbols"
              :active="activeTab.id === item.id" @clicked="setActiveTab(item)" /> -->
          </div>
        </div>
        <CreatePortfolio v-if="showCreatePortfolioPanel" @close="showCreatePortfolioPanel = false" />
        <div class="content">
          <Watchlist v-if="activeTab.id === 'watchlist'" />
          <Portfolio v-else :id="activeTab.id" :name="activeTab.name" @deleted="removeTab(activeTab.id)" />
        </div>
      </loading-container>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import LoadingContainer from "@/components/Misc/LoadingContainer";
import Watchlist from './Watchlist/Watchlist.vue';
import Portfolio from './Portfolio/Portfolio.vue';
import Headline from '@/components/Common/Headline.vue';
import CreatePortfolio from './Portfolio/CreatePortfolio.vue';
import FormButton from '@/components/Form/FormButton';
import { mapGetters, mapActions } from "vuex";

export default {
  name: "PremiumDashboard",
  components: {
    LoadingContainer,
    Headline,
    Watchlist,
    FormButton,
    Portfolio,
    CreatePortfolio
  },
  beforeMount() {
    this.getPortfolios();
  },
  data() {
    return {
      // activeTab: {
      //   id: 'watchlist',
      //   name: "Watchlist",
      //   mode: 'expiriment',
      //   noOfSymbols: 0
      // },
      showCreatePortfolioPanel: false,
    };
  },
  computed: {
    ...mapGetters({
      form: "portfolio/form",
      vplist: "portfolio/vplist",
      portfolio: "portfolio/portfolio",
      activeTab: "portfolio/activeTab"
    }),
    filterTypeOptions() {
      return common.getTypeOptions();
    },
    filterSectorOptions() {
      return this.sectors;
    },
  },
  methods: {
    ...mapActions({
      getPortfolios: "portfolio/getPortfolios",
      getPortfolioDetail: "portfolio/getPortfolioDetail",
      removePortfolio: "portfolio/removePortfolio",
      selectActiveTab: "portfolio/selectActiveTab"
    }),
    removeTab(pid) {
      this.removePortfolio(pid);
      this.setActiveTab({
        id: 'watchlist',
        name: "Watchlist",
        mode: 'expiriment',
        noOfSymbols: 0
      });
    },
    setActiveTab(tab) {
      console.log(tab.id);
      if (tab && tab.id !== this.activeTab.id) {
        this.selectActiveTab(tab);
      }
    },
  }
};
</script>

<style>
.headline-row {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  white-space: nowrap;
  align-items: center;
  margin-left: 10px;
  margin-top: 10px;
}

.headline-row::-webkit-scrollbar {
  display: none;
}

.headline-row {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.content {
  /* margin-top: 10px; */
  width: 100%;
}
</style>